(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["faq-search"] && !Shopify.designMode) return;
  try {
    class FaqSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-faq-search-input]');
      this.clearBtn = this.querySelector('[data-faq-search-clear]');
      this.statusEl = this.querySelector('[data-faq-search-status]');
      this.faqContent = this.closest('.faq__content');

      if (!this.faqContent || !this.input) {
        this.hidden = true;
        return;
      }

      this.statusTemplate = this.dataset.statusTemplate || '{count} results';
      this.statusOne = this.dataset.statusOne || '1 result';
      this.statusZero = this.dataset.statusZero || 'No results.';

      this.cards = this.indexCards();

      this.input.addEventListener('input', () => this.handleInput());
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.input.value) {
          e.stopPropagation();
          this.clearSearch();
        }
      });
      // mousedown preventDefault keeps focus on the input when the user
       // clicks the clear button. Without this, the input briefly loses
       // focus on mousedown, the bar's :focus-within toggles off, and the
       // border-color transition runs back to the resting state — then
       // the click handler re-focuses the input and the transition runs
       // forward again. Result: a 200ms flicker on every clear click.
      this.clearBtn.addEventListener('mousedown', (e) => e.preventDefault());
      this.clearBtn.addEventListener('click', () => this.clearSearch());
    }

    indexCards() {
      const items = [];
      let currentCategory = null;
      for (const el of this.faqContent.children) {
        if (el === this) continue;
        if (el.classList.contains('faq__category')) {
          currentCategory = { el, text: el.textContent.toLowerCase().trim() };
          items.push({ kind: 'category', el, text: currentCategory.text });
        } else {
          const details = el.matches('details') ? el : el.querySelector('details');
          if (!details) continue;
          const summary = details.querySelector('summary');
          const summaryText = (summary && summary.textContent) || '';
          const bodyText = details.textContent || '';
          items.push({
            kind: 'question',
            el,
            details,
            summary,
            category: currentCategory,
            searchText: (summaryText + ' ' + bodyText).toLowerCase()
          });
        }
      }
      return items;
    }

    handleInput() {
      const q = this.input.value.trim().toLowerCase();
      this.clearBtn.hidden = !q;
      this.unhighlightAll();

      if (!q) {
        this.resetView();
        return;
      }

      let matchCount = 0;
      const visibleCategories = new WeakSet();

      for (const item of this.cards) {
        if (item.kind !== 'question') continue;
        const inCategory = item.category && item.category.text.includes(q);
        const matches = item.searchText.includes(q) || inCategory;

        if (matches) {
          item.el.hidden = false;
          this.setAccordionOpen(item, true);
          matchCount++;
          if (item.category) visibleCategories.add(item.category.el);
          this.highlight(item.summary, q);
          this.highlight(item.details.querySelector('.accordion__content'), q);
        } else {
          item.el.hidden = true;
          this.setAccordionOpen(item, false);
        }
      }

      for (const item of this.cards) {
        if (item.kind === 'category') {
          item.el.hidden = !visibleCategories.has(item.el);
        }
      }

      this.statusEl.textContent =
        matchCount === 0
          ? this.statusZero
          : matchCount === 1
            ? this.statusOne
            : this.statusTemplate.replace('{count}', matchCount);
    }

    resetView() {
      // Restore visibility for every card. Deliberately do NOT close
      // details that are currently open — closing 6+ accordions in the
      // same frame triggers Stretch's per-accordion height transitions,
      // collapsing .faq__content's height by hundreds of pixels mid-paint.
      // The sticky bar's containing block shrinks underneath it and the
      // bar visibly jumps / disappears / re-appears as the layout settles.
      // Leaving open accordions alone means clearing is a no-op for layout
      // height — the bar stays put and the page state is preserved.
      for (const item of this.cards) {
        item.el.hidden = false;
      }
      this.statusEl.textContent = '';
    }

    clearSearch() {
      this.input.value = '';
      this.handleInput();
      // No explicit focus() call: the clear button's mousedown handler
      // already preventDefault'd, so the input never lost focus to begin
      // with. Calling focus() here would be a no-op at best and at worst
      // would scroll the input into view if it were programmatically
      // moved — neither is wanted.
    }

    // Stretch's <accordion-disclosure> tracks state via a CSS class
    // `is-open` on the wrapper, NOT via <details>.open. Its summary
    // click handler (theme.js:4207) preventDefault's the native toggle,
    // toggles `is-open`, then calls open_fn / close_fn based on the
    // class. If we set details.open directly without syncing the class,
    // the wrapper's state is desynced — and on the user's next click
    // the class flips to `is-open` (thinking it was closed), which then
    // RE-OPENS an already-open detail with an animation. Visible bug:
    // the row "re-renders / disappears / re-appears" instead of closing.
    // Sync both ourselves: class + details.open in lockstep.
    setAccordionOpen(item, open) {
      item.el.classList.toggle('is-open', open);
      item.details.open = open;
    }

    highlight(rootEl, query) {
      if (!rootEl || !query) return;
      const pattern = new RegExp(this.escapeRe(query), 'gi');
      const walker = document.createTreeWalker(rootEl, NodeFilter.SHOW_TEXT, {
        acceptNode: (node) => {
          const parent = node.parentElement;
          if (!parent) return NodeFilter.FILTER_REJECT;
          if (parent.classList && parent.classList.contains('faq-search__hit')) return NodeFilter.FILTER_REJECT;
          if (parent.tagName === 'SCRIPT' || parent.tagName === 'STYLE') return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });

      const targets = [];
      while (walker.nextNode()) targets.push(walker.currentNode);

      for (const node of targets) {
        const value = node.nodeValue;
        if (!value) continue;
        pattern.lastIndex = 0;
        if (!pattern.test(value)) continue;
        pattern.lastIndex = 0;

        const fragment = document.createDocumentFragment();
        let last = 0;
        let m;
        while ((m = pattern.exec(value)) !== null) {
          if (m.index > last) {
            fragment.appendChild(document.createTextNode(value.slice(last, m.index)));
          }
          const mark = document.createElement('mark');
          mark.className = 'faq-search__hit';
          mark.textContent = m[0];
          fragment.appendChild(mark);
          last = m.index + m[0].length;
          if (m[0].length === 0) pattern.lastIndex++;
        }
        if (last < value.length) {
          fragment.appendChild(document.createTextNode(value.slice(last)));
        }
        node.replaceWith(fragment);
      }
    }

    unhighlightAll() {
      if (!this.faqContent) return;
      const marks = this.faqContent.querySelectorAll('mark.faq-search__hit');
      for (const m of marks) {
        m.replaceWith(document.createTextNode(m.textContent));
      }
      if (marks.length) this.faqContent.normalize();
    }

    escapeRe(s) {
      return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
  }

  if (!customElements.get('faq-search')) {
    customElements.define('faq-search', FaqSearch);
  }
  } catch(e) { console.error(e); }
})();

})();
